import {useAppDispatch, useAppSelector} from './useReduxHooks'
import * as service from '../redux/reducers/auth/service'
import {actions} from '../redux/reducers/auth/slice'
import * as globalActions from '../redux/reducers/global/globalSlice'
import {
  LoginRequest,
  MeRequest,
  ResetPasswordRequest,
  ForgottenPasswordRequest,
} from '../redux/reducers/auth/types'
import {shallowEqual} from 'react-redux'
export default function useAuth() {
  const dispatch = useAppDispatch()
  const {actionLoading, me} = useAppSelector((state) => state.auth, shallowEqual)

  const login = (props: LoginRequest) => {
    return dispatch(service.login(props))
  }

  const logout = () => {
    return dispatch(actions.logout())
  }

  const requestResetPassword = (payload: ForgottenPasswordRequest) => {
    return dispatch(service.requestForgottenPassword(payload))
  }

  const resetPassword = (payload: ResetPasswordRequest) => {
    return dispatch(service.resetPassword(payload))
  }

  const getMe = (props: MeRequest) => {
    const auth_token_key = process.env.REACT_APP_AUTH_TOKEN_KEY!
    const token = localStorage.getItem(auth_token_key)
    if (token) {
      dispatch(service.getMe(props))
    }
  }

  return {
    actionLoading,
    me,
    login,
    logout,
    getMe,
    requestResetPassword,
    resetPassword,
  }
}
